// @ts-nocheck legacy file transformed to TS
import styled from '@emotion/styled'

const Divider = styled.div`
  height: 1px;
  width: 100%;
  background-color: #eee;
`

export default Divider
